import React from "react";
import { Card } from "antd";
import { Title } from "@frontend/components/atoms/Title";

const CardConfig = ({ children }) => {
  return (
    <Card
      title={
        <Title className="general-config-mainTitle" level={4}>
          Ajustes de perfil
        </Title>
      }
      className="general-config"
    >
      {children}
    </Card>
  );
};

export default CardConfig;
